export default __webpack_public_path__ + "static/klarna-pink-ba7ab6b0369b14965db4213abc3f8c79.svg";